<div> 
    <div class="card">
      <div class="card-header">
        <p><strong>Ingrese los datos de la nueva autoridad</strong></p>
      </div>
      <div class="card-body">
        <div class="container">
            <div class="row" style="background-color: rgba#e2e2e2;">
              <p>1.Datos básicos</p>
                <div class="col">
                    <input type="text"  [(ngModel)]="nombre" class="form-control" placeholder="Nombre" (input)="validaboton()"   >
                </div>
                <div class="col">
                  <!-- <div class="input-group mb-3">
                      <input type="text" [(ngModel)]="email" class="form-control" placeholder="email" aria-label="Recipient's username" aria-describedby="basic-addon2" (input)="validaboton()"  >
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">@grantierra.com</span>
                      </div>
                  </div> -->
                  <div class="input-group mb-3">
                      <input type="text" [(ngModel)]="email" class="form-control" placeholder="email" aria-label="Recipient's username" aria-describedby="basic-addon2" (input)="validaboton()"  >
                      
                  </div>
              </div>
              <div class="col">
                    <div class="form-group">
                      <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="dominio">
                        <option *ngFor="let item of arraydeempresas">{{item.data().dominio}}</option>
                      </select>
                    </div>
              </div>
              <div class="col">
                    <input type="text"  [(ngModel)]="password" class="form-control" placeholder="Clave" (input)="validaboton()" >
              </div>
            </div>
            <hr>
            <div class="row" style="background-color: rgba#9b9a9a;" >
              <p>2. Seleccione una regional / cuenca: - </p>
              <div class="form-group">
                <!-- <label for="exampleFormControlSelect1">Seleccione una regional / cuenca</label> -->
                <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="regional" (change)="validaboton()" >
                  <option>Putumayo Norte</option>
                  <option>Putumayo Sur</option>
                  <option>VMM</option>
                  <option>VMM-otros</option>
                  <option>Administración Bog.</option>
                  <option>Llanos</option>
                  <option>Charapa</option>
                  <option>Chanangue</option>
                  <option>Iguana</option>
                  <option>Conejo</option>
                  <option>Perico</option>
                  <option>Espejo</option>
                </select>
              </div>
            </div>
            <hr>
            <div class="row" style="background-color: rgba#e2e2e2;">
              <p>3. Seleccione una o varias de las opciones de autoridad:</p>
              <div class="col">
                <!-- Default inline 1-->
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="defaultInline1" [(ngModel)]="autoridadAislante" (change)="validaboton()">
                    <label class="custom-control-label" for="defaultInline1">Autoridad Aislante Mecánica / Neumática</label>
                  </div>

                  <!-- Default inline 2-->
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="defaultInline2" [(ngModel)]="autoridadArea" (change)="validaboton()">
                    <label class="custom-control-label" for="defaultInline2">Autoridad de área</label>
                  </div>

                  <!-- Default inline 3-->
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="defaultInline3" [(ngModel)]="autoridadAreaLocal" (change)="validaboton()">
                    <label class="custom-control-label" for="defaultInline3">Autoridad de área local</label>
                  </div>

                  <!-- Default inline 3-->
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="defaultInline4" [(ngModel)]="autoridadHSE" (change)="validaboton()">
                    <label class="custom-control-label" for="defaultInline4">Autoridad HSE</label>
                  </div>

                  <!-- Default inline 3-->
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="defaultInline5" [(ngModel)]="gerenteRegional" (change)="validaboton()">
                    <label class="custom-control-label" for="defaultInline5">Gerente regional</label>
                  </div>

                   <!-- Default inline 3-->
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="defaultInline6" [(ngModel)]="auditor" (change)="validaboton()">
                    <label class="custom-control-label" for="defaultInline6">Auditor</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="defaultInline7" [(ngModel)]="autoridadAmbiental" (change)="validaboton()">
                    <label class="custom-control-label" for="defaultInline7">Autoridad Ambiental</label>
                  </div>

                  <!-- Default inline 1-->
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="defaultInline8" [(ngModel)]="autoridadElectrica" (change)="validaboton()">
                    <label class="custom-control-label" for="defaultInline8">Autoridad Aislante Eléctrica</label>
                  </div>


              </div>
            </div>
        </div>
        <div *ngIf="alertaActiva">
            <p>
                <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }}</ngb-alert>
            </p>
        </div>
        
        <div>
          <hr>
          <button class="btn btn-success btn-block" (click)="crearUsuario()" [disabled]="botondisabled" style="float: right; margin-right: 6px;"  >¡Crear usuario!</button>
        </div>
      </div>
    </div>
  </div>

  <div class="container">

    <div  color="light" >
        <div style="text-align: center; color: rgb(15, 71, 145);"><h3>Lista de autoridades creadas</h3></div>
        <!-- <div style="text-align: center; color: rgb(15, 71, 145);"><p>Los usuarios creados son aquellos que pueden ingresar a la aplicación, pero aún no han diligenciado sus datos en ella.</p></div> -->
        
  
          <table datatable [dtOptions]="dtOptions"[dtTrigger]="dtTrigger" class="row-border hover" id="tabla"  >
            <thead>
              <tr>
                <th>Acciones</th>
                <th>email</th>
                <th>nombre</th>
                <th>regional</th>
                <th>autoridadAislante</th>
                <th>autoridadElectrica</th>
                <th>autoridadHSE</th>
                <th>autoridadArea</th>
                <th>autoridadAreaLocal</th>
                <th>gerenteRegional</th>
                <th>autoridadAmbiental</th>
  
              </tr>
            </thead>
            <tbody>

              <tr *ngFor="let item of arraydeposts">
                <td><button type="button" class="btn btn-primary btn-sm" (click)="detallesUsuario(item)"> Acciones</button></td>
                <td><small>{{item.data().email}}</small></td>
                <td><small>{{item.data().nombre}}</small></td>
                <td><small>{{item.data().regional}}</small></td>
                <td><small>{{item.data().autoridadAislante}}</small></td>
                <td><small>{{item.data().autoridadElectrica}}</small></td>
                <td><small>{{item.data().autoridadHSE}}</small></td>
                <td><small>{{item.data().autoridadArea}}</small></td>
                <td><small>{{item.data().autoridadAreaLocal}}</small></td>
                <td><small>{{item.data().gerenteRegional}}</small></td>
                <td><small>{{item.data().autoridadAmbiental}}</small></td>
              </tr>
              
            </tbody>
          </table>
  
         </div> 


  </div>